/**
 * French translations (flat format to avoid nesting issues)
 */
export default {
  // Basic words
  "language": "Langue",
  "title": "Rendez-vous de Livraison",
  "confirm": "Confirmer le Rendez-vous",

  // Basic information
  "baseInfo.title": "Informations de base",
  "baseInfo.name": "Nom",
  "baseInfo.phone": "Contact",
  "baseInfo.address": "Adresse d'installation",
  "baseInfo.expectDate": "Date de visite prévue",
  "baseInfo.service": "Contenu du service",
  "baseInfo.extra": "Exigences supplémentaires",
  "baseInfo.remark": "Remarque",
  "baseInfo.remarkPlaceholder": "Veuillez saisir",
  "baseInfo.fillName": "Veuillez saisir votre nom",
  "baseInfo.fillContact": "Veuillez saisir vos coordonnées",
  "baseInfo.fillAddress": "Veuillez saisir l'adresse d'installation",
  "baseInfo.selectService": "Veuillez sélectionner le service",
  "baseInfo.selectDate": "Veuillez sélectionner la date de visite prévue",

  // Appointment related
  "appointment.title": "Heure du Rendez-vous",
  "appointment.warning": "En cas d'échec de livraison pour des raisons client, 40$ seront facturés",
  "appointment.days.today": "Aujourd'hui",
  "appointment.days.tomorrow": "Demain",
  "appointment.days.monday": "Lundi",
  "appointment.days.tuesday": "Mardi",
  "appointment.days.wednesday": "Mercredi",
  "appointment.days.thursday": "Jeudi",
  "appointment.days.friday": "Vendredi",
  "appointment.days.saturday": "Samedi",
  "appointment.days.sunday": "Dimanche",
  "appointment.timeSlot.title": "Sélectionner Créneau",
  "appointment.timeSlot.slot1": "08:00-11:00",
  "appointment.timeSlot.slot2": "10:00-13:00",
  "appointment.timeSlot.slot3": "12:00-15:00",
  "appointment.timeSlot.slot4": "14:00-17:00",
  "appointment.timeSlot.slot5": "17:00-20:00",

  // Contact information
  "contact.title": "Contact Secondaire",
  "contact.mobile": "Mobile",
  "contact.email": "Email",
  "contact.placeholder": "Veuillez saisir",

  // Door information
  "doorInfo.title": "Informations de Portail",
  "doorInfo.hasDoor": "Avec Portail",
  "doorInfo.noDoor": "Sans Portail",
  "doorInfo.passwordTitle": "Mot de Passe du Portail",
  "doorInfo.passwordPlaceholder": "Entrez le code du portail",
  "doorInfo.passwordRequired": "Code du portail requis",

  // Delivery method
  "delivery.title": "Emplacement de Livraison",
  "delivery.placeholder": "Veuillez sélectionner",
  "delivery.photoOptional": "Optionnel",
  "delivery.photoPlaceholder": "Télécharger photo d'emplacement",
  "delivery.photoUploadSuccess": "Photo téléchargée",
  "delivery.photoDeleted": "Photo supprimée",
  "delivery.viewPhoto": "Voir la Photo",
  "delivery.noPhotoAvailable": "Aucune photo disponible",
  "delivery.locations.frontPorch": "Porche Avant",
  "delivery.locations.garage": "Garage",
  "delivery.locations.backDoor": "Porte Arrière",
  "delivery.locations.sideEntrance": "Entrée Latérale",
  "delivery.locations.buildingLobby": "Hall d'Immeuble",

  // Installation
  "installation.title": "Installation Nécessaire",
  "installation.yes": "Oui",
  "installation.no": "Non",

  // Stairs
  "stairs.title": "Livraison à l'Étage Nécessaire",
  "stairs.yes": "Oui",
  "stairs.no": "Non",

  // Success popup
  "successPopup.title": "Rendez-vous Réussi",
  "successPopup.appointmentTime": "Heure de Livraison",
  "successPopup.cancellationNote": "Si la livraison échoue pour des raisons du client, 40$ seront facturés",
  "successPopup.viewDetails": "Voir les Détails du Rendez-vous",

  // Error messages
  "errors.noTrackingNumber": "Aucun numéro de suivi valide trouvé",
  "errors.apiError": "Échec d'obtention des informations de rendez-vous",
  "errors.networkError": "Échec de la requête réseau, veuillez réessayer plus tard",
  "errors.selectTimeSlot": "Veuillez sélectionner un créneau horaire",

  // Order details
  "orderDetail.title": "Détails du Rendez-vous",
  "orderDetail.editAppointment": "Modifier le Rendez-vous",
  "orderDetail.loading": "Chargement...",
  "orderDetail.customerService": "Appeler le Service Client",

  // Avis (Review) related
  "review.title": "Avis du client",
  "review.areYouSatisfied": "Êtes-vous satisfait de ce service d'installation ?",
  "review.satisfied": "Satisfait",
  "review.disatisfied": "Non satisfait",
  "review.pleaseRateService": "Veuillez évaluer ce service",
  "review.overallScore": "Note globale",
  "review.workEfficiency": "Efficacité du travail",
  "review.communicationExperience": "Expérience de communication",
  "review.yourImpression": "Votre impression du technicien",
  "review.confirmSignature": "Confirmer la signature",
  "review.reSign": "Re-signer",
  "review.clickSign": "Cliquez pour signer",
  "review.file": "Fichier de signature",
  "review.comment": "Commentaire",
  "review.enterComment": "Veuillez entrer votre commentaire",
  "review.submit": "Soumettre",
  "review.noOrderNo": "Numéro de commande manquant",
  "review.selectSatisfaction": "Veuillez sélectionner la satisfaction",
  "review.selectTags": "Veuillez sélectionner les étiquettes d'impression",
  "review.selectInteractScore": "Veuillez évaluer la communication",
  "review.selectWorkScore": "Veuillez évaluer l'efficacité du travail",
  "review.selectServiceScore": "Veuillez évaluer la note globale",
  "review.signRequired": "Veuillez signer d'abord",
  "review.thanks": "Merci pour votre avis !",
  "review.scoreUnit": "pt",

  // Page d'accueil (index) liée
  "index.title": "Rendez-vous d'installation",
  "index.flowCardTitle": "Processus d'installation",
  "index.prepareCardTitle": "Préparation avant l'installation",
  "index.step1Title": "Soumettre les informations de rendez-vous",
  "index.step1Desc": "Veuillez remplir soigneusement les informations de rendez-vous, prendre et télécharger des photos réelles de l'environnement d'installation si nécessaire pour aider les techniciens à comprendre la situation à l'avance.",
  "index.step2Title": "L'électricien accepte la commande / Communication avant la visite",
  "index.step2Desc": "Après que l'électricien a accepté la commande, il communiquera les détails du service et confirmera l'heure du service avec vous.",
  "index.step3Title": "Travail sur site",
  "index.step3Desc": "Veuillez préparer la zone d'installation avant l'arrivée du technicien et l'informer à temps en cas de circonstances particulières.",
  "index.step4Title": "Confirmation de l'achèvement / Évaluation du service",
  "index.step4Desc": "Veuillez superviser le travail du technicien à tout moment, confirmer et signer après l'achèvement, et vous êtes invité à donner une évaluation réelle du service du technicien.",
  "index.prepare1": "Assurez-vous que la zone d'installation est propre et bien rangée, et retirez les obstacles qui pourraient affecter l'installation.",
  "index.prepare2": "Si vous devez retirer l'ancien équipement, veuillez sauvegarder et transférer les données à l'avance.",
  "index.customerService": "Service Client",
  "index.callHotline": "Appeler la hotline",
  "index.nextStep": "Étape suivante",
  "index.noOrderNoTip": "Veuillez contacter le service client pour obtenir le lien de commande",

  // Progression des étapes liée
  "stepProgress.title": "Étapes de la demande",
  "stepProgress.installDesc": "Instructions d'installation",
  "stepProgress.basicInfo": "Informations de base",
  "stepProgress.installPosition": "Position d'installation",
  "stepProgress.circuitInfo": "Informations sur le circuit",
  "stepProgress.finish": "Rendez-vous terminé",

  // Common words
  "common.cancel": "Annuler",
  "common.confirm": "Confirmer",
  "common.prev": "Précédent",
  "common.next": "Suivant",

  // ExtraSelectPopup related
  "extra.title": "Exigences supplémentaires",
  "extra.sub": "Sélection multiple autorisée",
  "extra.confirm": "Confirmer",
  "extra.需要布线": "Câblage requis",
  "extra.需要拆除旧设备": "Retrait de l'ancien équipement",
  "extra.需要打孔": "Perçage requis",
  "extra.需要接油机": "Connexion à la machine à huile",
  "extra.需要配件适配": "Adaptation des accessoires",

  // ServiceSelectPopup related
  "service.title": "Sélectionner le contenu du service",
  "service.confirm": "Confirmer",

  // New keys for InstallationPosition
  "install.title": "Position d'installation",
  "install.position": "Position d'installation",
  "install.wallType": "Type de mur",
  "install.select": "Veuillez sélectionner",
  "install.photo": "Photo de la position d'installation",
  "install.photoTip": "Veuillez prendre des photos de la position d'installation sous plusieurs angles pour l'évaluation du technicien",
  "install.concrete": "Béton",
  "install.wood": "Bois",
  "install.wall": "Mur",
  "install.ground": "Sol",
  "install.onlyJpgPng": "Seuls les formats JPG/PNG sont pris en charge",
  "install.maxSize": "La taille de l'image ne peut pas dépasser 5 Mo",
  "install.fileTypeError": "Erreur de type de fichier",
  "install.uploadFail": "Échec du téléchargement",
  "install.selectWallType": "Veuillez sélectionner le type de mur",
  "install.selectPosition": "Veuillez sélectionner la position d'installation",
  "install.uploadPhoto": "Veuillez télécharger la photo de la position d'installation",

  // Circuit related
  "circuit.title": "Informations sur le circuit",
  "circuit.mainBox": "Tableau principal",
  "circuit.mainBoxTip": "Veuillez photographier l'interrupteur le plus à l'intérieur pour évaluer l'alimentation électrique.",
  "circuit.meter": "Compteur électrique",
  "circuit.wire": "Réserve de câbles et environnement",
  "circuit.distance": "Distance du tableau de distribution au smart panel",
  "circuit.distanceTip": "Veuillez enregistrer ou télécharger une vidéo pour aider les techniciens à évaluer la difficulté d'installation et les matériaux nécessaires.",
  "circuit.submit": "Soumettre les informations",
  "circuit.onlyJpgPng": "Seuls les formats JPG/PNG sont pris en charge",
  "circuit.maxSize": "La taille de l'image ne peut pas dépasser 15 Mo",
  "circuit.onlyVideo": "Seuls les fichiers vidéo sont pris en charge",
  "circuit.maxVideoSize": "La taille de la vidéo ne peut pas dépasser 150 Mo",
  "circuit.fileTypeError": "Erreur de type de fichier",
  "circuit.uploadFail": "Échec du téléchargement",
  "circuit.uploadMainBox": "Veuillez télécharger la photo du tableau principal",
  "circuit.uploadMeter": "Veuillez télécharger la photo du compteur électrique",
  "circuit.uploadWire": "Veuillez télécharger la photo de la réserve de câbles et de l'environnement",
  "circuit.uploadDistance": "Veuillez télécharger la vidéo de la distance",
  "circuit.submitSuccess": "Soumission réussie",
  "circuit.networkError": "Erreur réseau, échec de la soumission",

  // OrderSuccess related
  "orderSuccess.title": "Rendez-vous terminé",
  "orderSuccess.success": "Rendez-vous réussi",
  "orderSuccess.orderId": "N° de commande :",
  "orderSuccess.address": "Adresse d'installation",
  "orderSuccess.name": "Nom",
  "orderSuccess.phone": "Téléphone",
  "orderSuccess.expectTime": "Heure de visite prévue",
  "orderSuccess.customerService": "Service Client",
  "orderSuccess.callHotline": "Appeler la hotline",

  // DatePickerPopup related
  "datePicker.title": "Heure de visite prévue",
  "datePicker.dateTitle": "Date prévue",
  "datePicker.dateTip": "Plusieurs dates peuvent être sélectionnées pour la planification du technicien",
  "datePicker.selected": "Sélectionné :",
  "datePicker.to": "à",
  "datePicker.period": "période",
  "datePicker.timeLabel": "Sélectionner le créneau horaire",
  "datePicker.time1": "08:00-12:00",
  "datePicker.time2": "13:00-17:00",
  "datePicker.time3": "18:00-21:00",
  "datePicker.month": "-",
  "datePicker.day": ""
}; 